"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const exercise_1 = require("@components/container/exercise");
const useWindowWidrh_1 = __importDefault(require("@hooks/useWindowWidrh"));
const quantityGame_1 = __importDefault(require("@components/quantity/quantityGame"));
const Pagination_1 = require("@components/Pagination");
const menuBarExercise_1 = __importDefault(require("@components/menuBar/menuBarExercise"));
const Button_1 = __importStar(require("@app/routes/SpeechDevelopment/components/Button"));
const translations_1 = require("@app/routes/SpeechDevelopment/translations");
const useCoins_1 = __importDefault(require("@hooks/useCoins"));
const exercise_js_1 = require("@app/routes/SpeechDevelopment/reducers/exercise.js");
const timer_1 = require("./timer");
const helpers_1 = require("@app/helpers");
const useIsProcessing_1 = require("@app/routes/SpeechDevelopment/hooks/useIsProcessing");
const LlmGeneralExerciseHandler_1 = require("./handlers/LlmGeneralExerciseHandler");
const components_1 = require("../../components");
const useSttStream_1 = require("@app/routes/SpeechDevelopment/hooks/useSttStream");
const exerciseRepetitionListWithBigImage_1 = __importDefault(require("@app/routes/SpeechDevelopment/components/BoxComponentWithImg/exerciseRepetitionListWithBigImage"));
const LlmGeneral = ({ exerciseParams, description }) => {
    var _a;
    const windowWidth = (0, useWindowWidrh_1.default)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const langId = (0, helpers_1.getCurrentLanguage)();
    const answers = (0, exercise_js_1.useSelectAnswers)();
    const currentCardIndex = (0, exercise_js_1.useSelectCurrentIndex)();
    const isStarted = (0, exercise_js_1.useSelectIsStarted)();
    const store = (0, react_redux_1.useSelector)(store => store);
    const [dialogueFlow, setDialogueFlow] = (0, react_1.useState)([]);
    const [recognizedText, setRecognizedText] = (0, react_1.useState)("");
    const { startRecognition, stopRecognition, isRecognizing, isLoading } = (0, useSttStream_1.useSttStream)({
        onFinal: (text) => setRecognizedText(text.toLowerCase())
    });
    const { coinCount, rubyCount, diamondCount, addCoin } = (0, useCoins_1.default)();
    const { isProcessing, setIsProcessing, canLeaf } = (0, useIsProcessing_1.useIsProcessing)();
    const exHandler = new LlmGeneralExerciseHandler_1.LlmGeneralExerciseHandler({
        store,
        dispatch,
        setIsProcessing,
        exerciseParams,
        langId,
        addCoin: () => __awaiter(void 0, void 0, void 0, function* () { return addCoin(3, 5); })
    });
    (0, react_1.useEffect)(() => {
        var _a;
        const firstQuestion = ((_a = exHandler.current) === null || _a === void 0 ? void 0 : _a.full_question) || "";
        if (firstQuestion)
            setDialogueFlow([{ assistant: firstQuestion, answer: "" }]);
    }, [currentCardIndex]);
    (0, react_1.useEffect)(() => {
        if (!recognizedText)
            return;
        console.log('recognizedText', recognizedText);
        if (isProcessing.current)
            return;
        setIsProcessing(true);
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const updatedFlow = (() => {
                const last = dialogueFlow[dialogueFlow.length - 1];
                if (last && last.assistant && !last.answer) {
                    return [
                        ...dialogueFlow.slice(0, -1),
                        { assistant: last.assistant, answer: recognizedText }
                    ];
                }
                return [...dialogueFlow, { assistant: "", answer: recognizedText }];
            })();
            setDialogueFlow(updatedFlow);
            const { comment, coverage, isLastAttempt } = yield exHandler.handleRecognized({
                text: recognizedText,
                dialogueFlow: updatedFlow,
            });
            if (comment && !isLastAttempt) {
                setDialogueFlow(prev => [...prev, { assistant: comment, answer: "" }]);
            }
            yield exHandler.handleAnswer(coverage);
            setIsProcessing(false);
        }))();
    }, [recognizedText]);
    const handleStart = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        if (!isStarted) {
            dispatch((0, exercise_js_1.setIsStarted)(true));
            exHandler.initInfoRep((_b = exHandler.current) === null || _b === void 0 ? void 0 : _b.id);
        }
        yield startRecognition();
    });
    const handleStop = () => {
        exHandler.stop();
        stopRecognition();
    };
    const handleNext = () => {
        exHandler.nextCard();
    };
    const handlePrev = () => {
        exHandler.previousCard();
    };
    const handleEndExercise = () => {
        exHandler.stopExercise();
        stopRecognition();
    };
    (0, react_1.useEffect)(() => {
        const handleCurrentCard = () => __awaiter(void 0, void 0, void 0, function* () {
            yield exHandler.playCurrentQuestion();
            (0, timer_1.startTimer)(() => __awaiter(void 0, void 0, void 0, function* () {
                setIsProcessing(true);
                yield exHandler.handleTimerOut();
                setIsProcessing(false);
            }));
        });
        if (isRecognizing)
            handleCurrentCard();
    }, [currentCardIndex, isRecognizing]);
    const answersFrameArray = exHandler.data
        .map(({ id }) => ({ isCorrect: false, id }));
    answersFrameArray.splice(0, answers.length, ...answers);
    const isPaused = isRecognizing && isRecognizing;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isLoading && react_1.default.createElement(components_1.Loader, null),
        react_1.default.createElement(exercise_1.ContainerExercise, null,
            react_1.default.createElement(exercise_1.ExerciseWrapper, { wihMargin: windowWidth <= 1200 },
                react_1.default.createElement(components_1.DropContainerWrapper, null,
                    react_1.default.createElement(exerciseRepetitionListWithBigImage_1.default, { list: [exHandler.current] }),
                    react_1.default.createElement(quantityGame_1.default, { diamondCount: diamondCount, rubyCount: rubyCount, goldCoin: coinCount })),
                react_1.default.createElement(Pagination_1.Pagination, null, answersFrameArray.map((item) => (react_1.default.createElement(Pagination_1.PaginationItem, { key: item.id, item: item }))))),
            react_1.default.createElement(menuBarExercise_1.default, null,
                react_1.default.createElement(Button_1.ButtonContainerWrapper, null,
                    react_1.default.createElement(Button_1.default, { label: "←", isShowShadow: false, disabled: currentCardIndex === 0 || !canLeaf, onClick: handlePrev }),
                    react_1.default.createElement(Button_1.default, { label: (0, translations_1.getLabelPauseButton)(langId, isRecognizing, isStarted && !isRecognizing), isShowShadow: true, isStarted: isStarted, onClick: isStarted ? handleEndExercise : handleStart, isCheckButton: false }),
                    react_1.default.createElement(Button_1.default, { label: isPaused ? "❚ ❚" : "▶", isShowShadow: false, onClick: isRecognizing ? handleStop : handleStart, disabled: !isStarted, color: isPaused ? '#F2A000' : null }),
                    react_1.default.createElement(Button_1.default, { label: "→", isShowShadow: false, disabled: currentCardIndex === ((_a = exerciseParams === null || exerciseParams === void 0 ? void 0 : exerciseParams.text) === null || _a === void 0 ? void 0 : _a.offers.length) - 1 || !isStarted || !canLeaf, onClick: handleNext }))))));
};
exports.default = LlmGeneral;
